export interface RecombinantCollectionsRequest {
  id: number
  prefix: string
  targetBibliographyRealId: number
  targetPrefix: string
  collections: {
    id: number
    revision: number
  }[]
}

export function RecombinantCollectionsRequestToJSON(
  value: RecombinantCollectionsRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    prefix: value.prefix !== '' ? value.prefix : undefined,
    target_bibliography_real_id: value.targetBibliographyRealId
      ? value.targetBibliographyRealId
      : undefined,
    target_prefix: value.targetPrefix !== '' ? value.targetPrefix : undefined,
    collections: value.collections.map(collection => {
      return {
        id: collection.id,
        revision: collection.revision
      }
    })
  }
}
